// MintLab apps shown on the landing page + valid app ids for the support form.
// `id` is the Play Store package id; the support form accepts ?app=<id>.

export const MINTLAB_APPS = [
  {
    id: "com.mintlab.fidgettoys",
    name: "Fidget Toys: Pop It Antistress",
    short: "Fidget Toys",
    descKey: "app.fidget.desc",
    icon: "/android/fidgettoys.png",
    gradient: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
  },
  {
    id: "com.mintlab.glowdoodle",
    name: "Glow Doodle: Neon Art Draw",
    short: "Glow Doodle",
    descKey: "app.glow.desc",
    icon: "/android/glowdoodle.png",
    gradient: "linear-gradient(135deg, #1e3a8a 0%, #0f172a 100%)",
  },
  {
    id: "com.memefx.brainrot.soundboard",
    name: "Brainrot Soundboard: Memes",
    short: "Brainrot Soundboard",
    descKey: "app.brainrot.desc",
    icon: "/android/brainrot.png",
    gradient: "linear-gradient(135deg, #0d9488 0%, #be123c 100%)",
  },
  {
    id: "com.mintlab.rainsounds",
    name: "Rain Sounds: Sleep Focus Mix",
    short: "Rain Sounds",
    descKey: "app.rain.desc",
    icon: "/android/rainsounds.png",
    gradient: "linear-gradient(135deg, #38bdf8 0%, #0369a1 100%)",
  },
  {
    id: "com.mintlab.traplab",
    name: "Trap Lab: Troll Rage Levels",
    short: "Trap Lab",
    descKey: "app.trap.desc",
    icon: "/android/traplab.png",
    gradient: "linear-gradient(135deg, #312e81 0%, #0f172a 100%)",
  },
  {
    id: "com.mintlab.slicelab",
    name: "ASMR Slicing: Sand Cut Game",
    short: "ASMR Slicing",
    descKey: "app.slice.desc",
    icon: "/android/slicelab.png",
    gradient: "linear-gradient(135deg, #a78bfa 0%, #6d28d9 100%)",
  },
  // Closed testing — shown as "coming soon" until `soon` is removed.
  {
    id: "com.mintlab.frosttap",
    name: "Frost Tap: ASMR Ice Crack",
    short: "Frost Tap",
    icon: "/android/frosttap.png",
    soon: true,
  },
  // Closed testing — shown as "coming soon" until `soon` is removed.
  {
    id: "com.mintlab.liquidlight",
    name: "Liquid Light: Neon Fluid Art",
    short: "Liquid Light",
    icon: "/android/liquidlight.png",
    soon: true,
  },
  // Closed testing — shown as "coming soon" until `soon` is removed.
  {
    id: "com.mintlab.sneakyboss",
    name: "Sneaky Office: Don't Wake Boss",
    short: "Sneaky Office",
    icon: "/android/sneakyboss.png",
    soon: true,
  },
  // Closed testing — shown as "coming soon" until `soon` is removed.
  {
    id: "com.mintlab.spinnerwheel",
    name: "Spinner Wheel: Decision Maker",
    short: "Spinner Wheel",
    icon: "/android/spinnerwheel.png",
    soon: true,
  },
];

// iOS apps: shown on the home screen as "installing" (dimmed + progress ring)
// until `appStoreUrl` is filled in — then the icon lights up and links to the
// App Store. Also accepted by the support form (?app=<bundle id>).
export const IOS_APPS = [
  {
    id: "com.mintlab.isle",
    name: "Isle: Living Widget Island",
    short: "Isle",
    icon: "/isle/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.kitesong",
    name: "Sáo Diều: Kite Song",
    short: "Sáo Diều",
    icon: "/kitesong/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.teu",
    name: "Tễu: Water Puppet Theatre",
    short: "Tễu",
    icon: "/teu/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.rao",
    name: "Tiếng Rao: Street Cries of Hà Nội",
    short: "Tiếng Rao",
    icon: "/ios/rao.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.tho",
    name: "Thở: See the Air",
    short: "Thở",
    icon: "/ios/tho.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.sky",
    name: "Chung Trời",
    short: "Chung Trời",
    icon: "/sky/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.quan",
    name: "Ô Quan: Mandarin Squares",
    short: "Ô Quan",
    icon: "/quan/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.hoiba",
    name: "Hỏi Bà",
    short: "Hỏi Bà",
    icon: "/hoiba/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.domdom",
    name: "Đom Đóm: Firefly River",
    short: "Đom Đóm",
    icon: "/domdom/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.sonmai",
    name: "Sơn Mài",
    short: "Sơn Mài",
    icon: "/sonmai/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.bacthang",
    name: "Bậc Thang",
    short: "Bậc Thang",
    icon: "/bacthang/icon.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.hanggio",
    name: "Hang Gió",
    short: "Hang Gió",
    icon: "/ios/hanggio.png",
    appStoreUrl: null,
  },
  {
    id: "com.mintlab.fond",
    name: "Fond: Photo Cleaner & Recap",
    short: "Fond",
    icon: "/fond/icon.png",
    appStoreUrl: null,
  },
];

const ALL_APPS = [...MINTLAB_APPS, ...IOS_APPS];

export const APP_IDS = new Set(ALL_APPS.map((a) => a.id));

// Store link for a showcase app, or null while it's still "coming soon".
export function storeUrl(app) {
  if (IOS_APPS.includes(app)) return app.appStoreUrl || null;
  return app.soon ? null : playUrl(app.id);
}

const liveFirst = (apps) => [
  ...apps.filter((a) => storeUrl(a)),
  ...apps.filter((a) => !storeUrl(a)),
];

// Home-screen pages, one per platform (switched by the iPhone/Android control).
// Within a page: live apps first, then the upcoming ones.
export const SHOWCASE_PAGES = [
  { key: "ios", label: "iPhone", apps: liveFirst(IOS_APPS) },
  { key: "android", label: "Android", apps: liveFirst(MINTLAB_APPS) },
];

export function playUrl(id) {
  return `https://play.google.com/store/apps/details?id=${id}`;
}

export function appById(id) {
  return ALL_APPS.find((a) => a.id === id) || null;
}

export const PRIVACY_URL = "/privacy-policy.html";
// Terms currently point at the privacy doc until a dedicated terms page exists.
export const TERMS_URL = "/privacy-policy.html";
